export const paths = {
  account: {
    signout: '/users/sign_out',
    myProfile: (profile_url: string) => profile_url,
    profileChange: (profile: string) => `/profiles/set/${profile}`,
    admin: {
      curriculums: '/curriculums',
      school: '/schools',
      transfer_students: '/transfer_students',
      feature_flags: '/admin/feature-flags',
    },
  },
}
